"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("./theme");
var breakpoint = function (breakpoint) {
    var size = theme_1.defaultTheme.breakpoints[breakpoint];
    return "@media screen and (min-width: " + size + ")";
};
exports.default = breakpoint;
